import { render, staticRenderFns } from "./ResultDetailSacrificeOutLeft.vue?vue&type=template&id=16c7b2ae&scoped=true&"
import script from "./ResultDetailSacrificeOutLeft.vue?vue&type=script&lang=js&"
export * from "./ResultDetailSacrificeOutLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7b2ae",
  null
  
)

export default component.exports